import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'
import {getLS} from "./utils/localStorage-utils";
import UserConst from "./enums/user";

Vue.use(AclInstaller)

let initialRole = 'user'

const userInfo = JSON.parse(getLS('userInfo'))
if (userInfo) {
  if (userInfo.auth_flg == UserConst.AUTH_FLG_ADMIN){
    initialRole = 'admin';
  }else if (userInfo.auth_flg == UserConst.AUTH_SYS_ADMIN){
    initialRole = 'sys_admin';
  }else{
    initialRole = 'user';
  }
}

export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    sys_admin: new AclRule('sys_admin').generate(),
    admin  : new AclRule('admin').generate(),
    user : new AclRule('user').or('admin').or('sys_admin').generate()
  }
})
